import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/reporting/ag-grid-poc/')({
  async beforeLoad({ context }) {
    const flagsmith = await context.getInstance('flagsmith', '@mint/arm');
    const guardsContext = await context.getGuardContext(flagsmith);

    if (!guardsContext.flagsService?.hasFeature('reportingAgGridPoc')) {
      throw redirect({
        to: '/reporting',
      });
    }
  },
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');

    const title = i18n.t('AG Grid POC | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
